document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gift-addon-modal').forEach(function (modal) {
    document.body.appendChild(modal);
  });
});

document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.gift-addon-modal__close');
  if (!closeBtn) return;
  const modal = closeBtn.closest('modal-dialog');
  if (!modal) return;

  if (typeof modal.hide === 'function') {
    modal.hide();
  } else {
    modal.removeAttribute('open');
  }
});

document.addEventListener('click', function (e) {
  const button = e.target.closest('.gift-addon-modal__submit');
  if (!button) return;

  const variantId = button.getAttribute('data-variant-id');
  const noteFieldId = button.getAttribute('data-note-field');
  const noteField = noteFieldId ? document.getElementById(noteFieldId) : null;
  const statusEl = button.closest('.gift-addon-modal__content').querySelector('.gift-addon-modal__status');

  const maxLength = noteField && noteField.hasAttribute('maxlength')
    ? parseInt(noteField.getAttribute('maxlength'), 10)
    : null;
  const noteValue = noteField
    ? (maxLength ? noteField.value.trim().slice(0, maxLength) : noteField.value.trim())
    : '';
  const properties = {};
  if (noteValue !== '') {
    properties['Gift Note'] = noteValue;
  }

  button.disabled = true;
  statusEl.hidden = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: properties
        }
      ]
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        throw new Error(data.description || 'Could not add item');
      }

      statusEl.textContent = 'Added to cart!';
      statusEl.hidden = false;
      button.disabled = false;

      const modalId = button.closest('modal-dialog').id;
      const wrapper = document.querySelector('[data-modal="#' + modalId + '"]').closest('.gift-addon-wrapper');
      if (wrapper) {
        wrapper.classList.add('is-added');
        const preview = wrapper.querySelector('.gift-addon-note-preview');
        if (preview && noteValue !== '') {
          preview.textContent = '"' + noteValue + '"';
          preview.classList.add('has-note');
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      const modal = button.closest('modal-dialog');
      if (modal && typeof modal.hide === 'function') {
        setTimeout(() => modal.hide(), 900);
      } else if (modal) {
        setTimeout(() => modal.removeAttribute('open'), 900);
      }
    })
    .catch((error) => {
      statusEl.textContent = 'Something went wrong. Please try again.';
      statusEl.hidden = false;
      button.disabled = false;
    });
});